<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore, getHrefForMediaItem } from '../../../utilities';
import { Readable } from 'svelte/store';
import ActionButton from "../ActionButton/ActionButton.svelte";
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { CardsPageContext, CardsPageContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOSetState } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const pageContext = getContext(CardsPageContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: buttonLabel = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.buttonLabel) || "Register";
$: fieldMapping = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.fieldMapping) || {};
$: firstEmailKey = (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.emailKey;
$: emailValidKey = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.isValidEmailKey;
$: passwordKey = (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.passwordKey;
$: passwordValidKey = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.isValidPasswordKey;
$: useSportsAllianceRegistration = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.useSportsAllianceRegistration) || false;
$: useFMFRegistration = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.useFMFRegistration) || false;
$: loginPageUrl = ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.loginPageUrl) || 'Login';
$: endWorkflow = (_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.endWorkflow;
$: email = firstEmailKey ? ($mergedParams || {})[firstEmailKey] : '';
$: isEmailValid = emailValidKey ? ($mergedParams || {})[emailValidKey] : '';
$: password = passwordKey ? ($mergedParams || {})[passwordKey] : '';
$: passwordValid = passwordValidKey ? ($mergedParams || {})[passwordValidKey] : '';
/*
{
    "addressKey": {
        "type": "address",
        "profileKey": {
            "address_country": "address_country",
            "address_street": "address_street",
            "address_city": "address_city",
            "address_division_1": "address_division_1",
            "address_postal": "address_postal",
            "phone": "phone"
        },
        "required": {
            "address_country": true,
            "phone": true
        }
    },
    "firstNameKey": {
        "profileKey": "first_name",
        "required": true
    },
    ...
}
*/
$: formState = (function (mergedParams, fieldMapping) {
    var _a;
    const ret = { profile: {}, valid: true };
    for (let [formKey, config] of Object.entries(fieldMapping)) {
        if (!formKey || !config)
            continue;
        if (formKey.startsWith('$'))
            formKey = (mergedParams || {})[formKey.slice(1)];
        const formValue = (mergedParams || {})[formKey] || '';
        if (config.type === 'address') {
            const addressValue = (formValue) ? JSON.parse(formValue) : {};
            const profileKeyConfig = config.profileKey || {};
            for (const [addressSubkey, profileKey] of Object.entries(profileKeyConfig)) {
                if (!addressSubkey || !profileKey)
                    continue;
                const subkeyValue = addressValue[addressSubkey] || '';
                ret.profile[profileKey] = subkeyValue;
                if (((_a = config.required) === null || _a === void 0 ? void 0 : _a[addressSubkey]) === true && !subkeyValue) {
                    console.log('address subkey not valid: ', addressSubkey, addressValue, subkeyValue);
                    ret.valid = false;
                }
            }
        }
        else {
            let profileKey = config.profileKey;
            if (!profileKey)
                continue;
            if (profileKey.startsWith('$'))
                profileKey = (mergedParams || {})[profileKey.slice(1)];
            ret.profile[profileKey] = formValue;
            //console.log(`ret.profile[${profileKey}] = ${formValue} (${typeof formValue})`);
            if (config.required === true && (!formValue || formValue === 'false')) {
                console.log('profile key not valid', formKey, formValue);
                ret.valid = false;
            }
        }
    }
    // make sure booleans are sent as strings
    for (const [profileKey, profileValue] of Object.entries(ret.profile)) {
        if (_.isBoolean(profileValue)) {
            ret.profile[profileKey] = (profileValue) ? "true" : "false";
        }
    }
    console.log('GenericAccountRegisterButton formState: ', ret);
    return ret;
})($mergedParams, fieldMapping);
$: isValid = formState.valid && (firstEmailKey ? isEmailValid === "true" : true) && (passwordValidKey ? passwordValid === "true" : true);
const handleClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
    var _m, _o, _p;
    const profile = formState.profile;
    let result;
    f7.preloader.show('white');
    try {
        if (useSportsAllianceRegistration) {
            result = yield signonManager.registerWithSportsAllianceEmailPassword(email, password, profile);
        }
        else if (useFMFRegistration) {
            result = yield signonManager.registerWithFMFEmailPassword(email, password, profile);
        }
        else {
            result = yield signonManager.registerWithYinzCamEmailPassword(email, password, profile);
        }
    }
    finally {
        f7.preloader.hide();
    }
    console.log('SSO: register result', result);
    if (result.success) {
        ycSSOSetState(result.data.AccountCreated === 'true', result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
        if (endWorkflow) {
            signonManager.fireWorkflowEndEvent();
        }
        else if (signonManager.skipCompleteProfilePage) {
            resolveUrl(`ConnectAccounts`).func();
        }
        else {
            resolveUrl(`CompleteProfile?firstName=${firstName}&lastName=${lastName}&email=${email}`).func();
        }
    }
    else {
        alert(((_o = (_m = result.data) === null || _m === void 0 ? void 0 : _m.UserMessage) === null || _o === void 0 ? void 0 : _o.Content) || 'An error occurred.');
        if (((_p = result.data) === null || _p === void 0 ? void 0 : _p.ErrorCode) === 'EMAIL_VERIFICATION') {
            resolveUrl(loginPageUrl).func();
        }
    }
});
</script>
<CardBase {element}>
  <ActionButton onClick={handleClick} disabled={!isValid} title={buttonLabel}/>
</CardBase>